// Single source of truth for the current weekly briefing.
// Each Monday, update the fields below to point the homepage announcement bar
// and the homepage featured-insight card at the newest approved briefing.
// Set `active: false` to hide the announcement bar without removing it.

export const FEATURED_BRIEFING = {
  active: true,
  slug: "uae-africa-legal-regulatory-briefing-3-november-2026",
  title: "UAE–Africa Legal & Regulatory Briefing",
  dateRange: "27 October–2 November 2026",
  alertText: "UAE–Africa Legal & Regulatory Briefing: 27 October–2 November 2026",
  summary:
    "UAE e-invoicing appointment remediation, Nigerian sanctions screening, South African biometric verification consultation and the JSE comment deadline.",
  jurisdictions: ["UAE", "Nigeria", "South Africa", "Mauritius"],
};

export const briefingPath = (b = FEATURED_BRIEFING) => `/insights/${b.slug}`;
